<template>
    <div class="success-box">
        <h2>提交成功</h2>
        <p>作品信息已经成功提交，请耐心等待后续比赛结果。</p>
        <a href="">返回首页</a>
    </div>
</template>

<script>
    export default {
        name: 'Success'
    }
</script>

<style lang="scss">
    .success-box {
        width: 800px;
        margin: 0 auto;
        padding: 80px;
        text-align: center;
    }
</style>
